export const STOCK_STATUS_OPTIONS_REDUCER_NAME = 'stock-status-options';

export const stockStatusOptionsReducer = (state = {}) => state;

export const getStockStatusOptions = (state) => state[STOCK_STATUS_OPTIONS_REDUCER_NAME];
